<script lang="ts">
  import { setContext } from "svelte";
  import { writable } from "svelte/store";
  import type { Tab } from "./types";

  export let justifyRight: boolean = false;
  export let showDropShadow: boolean = true;
  export let startOn: string | null = null;
  const tabs = writable<Tab[]>([]);
  setContext("tabs", tabs);

  const activeTab = writable<string>(startOn ? startOn : "");
  setContext("activeTab", activeTab);

  tabs.subscribe((ts) =>
    activeTab.set(startOn ? startOn : ts.length > 0 ? ts[0].id : "")
  );

  const selectTab = (id: string) => () => {
    activeTab.set(id);
  };
</script>

<style>
  #tab-bar {
    font-family: var(--theme-font-regular), sans-serif;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1em;
  }
  .justifyRight {
    justify-content: flex-end;
  }

  .tab {
    cursor: pointer;
    color: #cbcbcb;
    font-weight: lighter;
    transition-property: color;
    transition-timing-function: cubic-bezier();
    transition-duration: 150ms;
  }

  .tab:not(:first-child) {
    margin-left: 1em;
  }

  .tab:hover {
    color: #4e4e4e;
  }

  .selected-tag {
    font-weight: normal;
    color: #4e4e4e;
  }

  #shadowed-box {
    width: 100%;
    height: 100%;
  }
  .shadow {
    box-shadow: 1px 1px 4px 0px #00000040;
  }
</style>

<div id="tab-bar" class:justifyRight>
  {#each $tabs as tab}
    <div
      class:selected-tag={tab.id === $activeTab}
      class="tab"
      on:click={selectTab(tab.id)}>
      {tab.title}
    </div>
  {/each}
</div>
<div id="shadowed-box" class:shadow={showDropShadow}>
  <slot {activeTab} />
</div>
